<template>
  <section class="about_service_area section_padding">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="about_service_left">
            <p class="about_service_year text-center">
              40
              <span>years
                        experience!</span>
            </p>
          </div><!--end .about_service_left-->
        </div><!--end .col-md-6-->
        <div class="col-md-6">
          <div class="about_service_right">
            <div class="hero-title-with-shape">
              <h4 class="heading_with_border">Why choose us</h4>
              <h1>We are a trusted source of plumbing installation and repairs company</h1>
            </div><!--end .hero-title-with-shape-->
            <ul>
              <li><i class="fa fa-check-circle"></i> Unmatched performance, satisfaction service guarantees</li>
              <li><i class="fa fa-check-circle"></i> Licensed and Insured</li>
              <li><i class="fa fa-check-circle"></i> 24 / 7 availability for all emergency services</li>
              <li><i class="fa fa-check-circle"></i> Trusted & Recommended since 1995 </li>
              <li><i class="fa fa-check-circle"></i> Free Estiamtes</li>
            </ul>
            <div class="about_service_discount text-center">
              <h1>10% off</h1>
              <p>on our all services for senior citizens.</p>
            </div><!--end .about_service_discount-->
          </div><!--end .about_service_right-->
        </div><!--end .col-md-6-->
      </div><!--end .row-->
    </div><!--end .container-->
  </section>
</template>

<script>
    export default {
      name: "ServicesTwo"
    }
</script>

<style scoped>

</style>
